import { render, staticRenderFns } from "./CpD_PageDetails_Actions.vue?vue&type=template&id=0b7fe98e"
import script from "./CpD_PageDetails_Actions.vue?vue&type=script&lang=js"
export * from "./CpD_PageDetails_Actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports